module.exports = __webpack_public_path__ + "img/loading.4645d4f7.svg";